import Container from "@/src/components/Container/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import YourServiceWorldCards from "./YourServiceWorldCards";
import React from "react";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";
import Section from "@/src/components/Section/Section";

const YourServiceWorld = () => {
  const { setView } = useAuthDialog();

  return (
    <Section>
      <Container
        variant={"md"}
        sx={{
          textAlign: "center",
        }}
      >
        <Typography variant={"h3"} component={"h2"}>
          Ihre Servicewelt
        </Typography>
        <Typography>
          In unserer Servicewelt können Sie in wenigen einfachen Schritten Ihre
          <br /> Fälle anlegen und jederzeit den aktuellen Stand einsehen.
        </Typography>

        <YourServiceWorldCards />

        <Button variant={"contained"} onClick={() => setView({ type: "login" })}>
          Zu Ihrer Servicewelt
        </Button>
      </Container>
    </Section>
  );
};

export default YourServiceWorld;
